module.exports = __webpack_public_path__ + "static/media/cb_ln.835ec646.png";